import { Module } from 'wrapper6'

const $ = jQuery

export default class Consent extends Module {
  ready (app) {
    this.CONSENT_BTNS = document.querySelectorAll('.button[data-id="consent"]')
    this.CONSENT_ACCEPT = document.querySelector('.modal[data-id="consent"] .consent-accept')
    this.CONSENT_DENY = document.querySelector('.modal[data-id="consent"] .consent-close')

    if (this.CONSENT_BTNS.length > 0) {
      this.land_url = document.querySelector('.modal[data-id="consent"]').getAttribute('data-url')
      this.url = this.CONSENT_BTNS[0].getAttribute('href')

      for (let i = 0; i < this.CONSENT_BTNS.length; i++) {
        const BTN = this.CONSENT_BTNS[i]
        BTN.addEventListener('click', () => this.url = BTN.getAttribute('href'))
      }

      this.CONSENT_ACCEPT && this.CONSENT_ACCEPT.addEventListener('click', () => this.accept())
      this.CONSENT_DENY && this.CONSENT_DENY.addEventListener('click', () => this.deny())
    }
  }

  accept () {
    window.open(this.url, '_blank')
  }

  deny () {
    if (this.land_url !== null) {
      window.location.href = this.land_url
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/modules/_consent.js